export function getValueWithFrameLimit(min: number, max: number, input: number): number {
  return Math.max(min, Math.min(input, max));
}

export function roundToDecimalFixed(value: number) {
  return parseFloat(value.toFixed(2));
}
